package com.rabbitsign.common.util

private val emailRegex = Regex(
    """^(?=.{1,64}@)[A-Za-z0-9-_+]+(\.[A-Za-z0-9-_+]+)*@[A-Za-z0-9][A-Za-z0-9-+]*(\.[A-Za-z0-9-+]+)*(\.[A-Za-z]{2,})$"""
)

fun String.looksLikeEmail(): Boolean = emailRegex.matches(this)
